module.exports = __webpack_public_path__ + "e6991b4cdd0b6932dcc03d06340db422.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/delete-note.png
// module id = 703
// module chunks = 0